module.exports = __webpack_public_path__ + "img/bg-top-left.8c9af540.png";